import { configureStore } from "@reduxjs/toolkit";

import common from "../features/admin/common/Slice";

import contactus from "./contactus";

import auth from "./auth";

import subscription from "./subscription";

import vendor_expert from "./vendor_expert";

//store
export const store = configureStore({
  reducer: {
    common: common,

    contactus,

    auth,

    subscription,

    vendor_expert,
  },
});
